export default __webpack_public_path__ + "static/slidebean-2b6f5f80ce8545ebfce84e1a0cda007f.png";